import { render, staticRenderFns } from "./EsMenu.vue?vue&type=template&id=97f7cbf4&scoped=true&"
import script from "./EsMenu.vue?vue&type=script&lang=js&"
export * from "./EsMenu.vue?vue&type=script&lang=js&"
import style0 from "./EsMenu.vue?vue&type=style&index=0&id=97f7cbf4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f7cbf4",
  null
  
)

export default component.exports